import React, { Fragment } from 'react'
import { Row, Col, Input, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import Switch from "react-switch";
// import PermissionWrapper from '../../auth/PermissionWrapper';


class ClientReconciliations extends React.Component {

    render = () => {
        this.props.info('ClientReconciliations.js/render');
        return (
            <Row>
                <Col md="12">
                    <table className="dataGrid wrap">
                        <thead>
                            <tr>
                                <th width="10%">Account</th>
                                <th wdith="10%">Account Recon</th>
                                <th width="25%">Account Recon Notes</th>
                                <th width="10%">Security</th>
                                <th width="10%">Security Type</th>
                                <th width="10%">Outage</th>
                                <th wdith="10%">Outage Recon</th>
                                <th width="25%">Outage Recon Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.selectedReport.reconciliations.filter(reconciliation => reconciliation.account.substr(0, 4) !== 'new-').map((reconciliation, index) => (
                                <Fragment key={index}>
                                    {reconciliation.outages.map((outage, outageIndex) => (
                                        <tr key={outageIndex} className={outageIndex === 0 ? 'newReconciliationAccount' : ''}>
                                            {outageIndex === 0 ? <>
                                                <td rowSpan={reconciliation.outages.length}>{reconciliation.account}</td>
                                                <td rowSpan={reconciliation.outages.length}>
                                                    <Switch
                                                        checked={reconciliation.outages.findIndex(item => item.recon === 'n') === -1}
                                                        disabled={reconciliation.outages.findIndex(item => item.recon === 'n') === -1 || outage.reconNotes === '' || outage.reconNotes == null}
                                                        className="react-switch"
                                                        onChange={() => this.props.submitReconciliation(reconciliation.outages[0].id)}
                                                    />
                                                </td>
                                                {/* <td rowSpan={reconciliation.outages.length}>{reconciliation.outages.findIndex(item => item.recon === 'n') > -1 ? 'n' : 'y'}</td> */}
                                                <td rowSpan={reconciliation.outages.length}>
                                                    {/* {reconciliation.outages.findIndex(item => item.recon === 'n') > -1 || 1 === 1 ? */}
                                                        <>
                                                            <Input
                                                                className='fieldWithRightButton'
                                                                type="textarea"
                                                                rows={5}
                                                                name={"reconNotes_" + reconciliation.outages[0].id + "_" + outage.id}
                                                                value={outage.reconNotes}
                                                                onChange={(e) => this.props.handleReconciliationTextInputChange(e)}
                                                            />
                                                            {outage.reconNotes.length > 0 && <Button
                                                                title="Reconcile Account"
                                                                // disabled={outage.reconNotes.length === 0}
                                                                className="p-0 fieldRightButton"
                                                                color="primary"
                                                                onClick={() => this.props.submitReconciliationNote(reconciliation.outages[0].id)}
                                                            ><FontAwesomeIcon icon={faCheck} /></Button>}
                                                        </>
                                                        {/* : <>{outage.reconNotes}
                                                            <div className="adjustUserDate">{outage.users[0].firstName} {outage.users[0].lastName} - {parseInt(outage.adjustTimestamp.substr(5, 2)) + '/' + parseInt(outage.adjustTimestamp.substr(8, 2)) + '/' + outage.adjustTimestamp.substr(2, 2)}</div>
                                                        </> */}
                                                        {/* } */}
                                                </td>
                                            </> : null
                                            }
                                            <td>{outage.security}</td>
                                            <td>{outage.securityType}</td>
                                            <td className='text-right'>{outage.adventCost.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            })}</td>
                                            <td>
                                                <Switch
                                                    onChange={() => this.props.submitReconciliationOutage(reconciliation.outages[0].id, outage.id)}
                                                    checked={outage.adjustRecon === 'y'}
                                                    className="react-switch"
                                                    disabled={outage.adjustRecon === 'y' || outage.adjustReconNotes === '' || outage.adjustReconNotes == null}
                                                />
                                            </td>
                                            {/* <td>{outage.adjustRecon}</td> */}
                                            <td>
                                                {/* {(outage.adjustRecon === 'n'  || 1 === 1)  ? */}
                                                    <>
                                                        <Input
                                                            className='fieldWithRightButton'
                                                            type="text"
                                                            name={"adjustReconNotes_" + reconciliation.outages[0].id + "_" + outage.id}
                                                            value={outage.adjustReconNotes}
                                                            onChange={(e) => this.props.handleReconciliationTextInputChange(e)}
                                                        />
                                                        {outage.adjustReconNotes.length > 0 && <Button
                                                            title="Reconcile Outage"
                                                            // disabled={outage.adjustReconNotes.length === 0}
                                                            className="p-0 fieldRightButton"
                                                            color="primary"
                                                            onClick={() => this.props.submitReconciliationOutageNote(reconciliation.outages[0].id, outage.id)}
                                                        ><FontAwesomeIcon icon={faCheck} /></Button>}
                                                    </>
                                                    {/* : <>{outage.adjustReconNotes}
                                                        <div className="adjustUserDate">{outage.users[0].firstName} {outage.users[0].lastName} - {parseInt(outage.adjustTimestamp.substr(5, 2)) + '/' + parseInt(outage.adjustTimestamp.substr(8, 2)) + '/' + outage.adjustTimestamp.substr(2, 2)}</div>
                                                    </>} */}

                                            </td>
                                        </tr>
                                    ))}
                                </Fragment>
                            )
                            )}
                        </tbody>
                    </table>
                </Col>
            </Row>
        )
    }
}

export default ClientReconciliations;